
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../services/api";
import "./AlterarSenha.css";

const IconeOlho = ({ aberto }) => (
  <svg
    viewBox="0 0 24 24"
    width="20"
    height="20"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {aberto ? (
      <>
        <path d="M3 3l18 18" />
        <path d="M10.6 10.6a2 2 0 0 0 2.8 2.8" />
        <path d="M9.9 5.2A11.5 11.5 0 0 1 12 5c5.5 0 9 7 9 7a14 14 0 0 1-3.1 3.9" />
        <path d="M6.2 6.2C3.9 7.8 3 12 3 12s3.5 7 9 7a9.8 9.8 0 0 0 3-.5" />
      </>
    ) : (
      <>
        <path d="M2.5 12s3.5-7 9.5-7 9.5 7 9.5 7-3.5 7-9.5 7-9.5-7-9.5-7Z" />
        <circle cx="12" cy="12" r="3" />
      </>
    )}
  </svg>
);

const IconeEscudo = () => (
  <svg
    viewBox="0 0 24 24"
    width="32"
    height="32"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M12 3 20 6v5c0 5-3.4 8.4-8 10-4.6-1.6-8-5-8-10V6l8-3Z" />
    <path d="m9 12 2 2 4-4" />
  </svg>
);

const AlterarSenha = () => {
  const navigate = useNavigate();

  const [senhaAtual, setSenhaAtual] = useState("");
  const [novaSenha, setNovaSenha] = useState("");
  const [confirmarSenha, setConfirmarSenha] = useState("");

  const [mostrarSenhaAtual, setMostrarSenhaAtual] = useState(false);
  const [mostrarNovaSenha, setMostrarNovaSenha] = useState(false);
  const [mostrarConfirmarSenha, setMostrarConfirmarSenha] =
    useState(false);

  const [mensagem, setMensagem] = useState("");
  const [tipoMensagem, setTipoMensagem] = useState("");
  const [carregando, setCarregando] = useState(false);
  const [verificandoAuth, setVerificandoAuth] = useState(true);

  useEffect(() => {
    let ativo = true;

    const verificarAutenticacao = async () => {
      try {
        await api.get("/verificar-autenticacao", {
          withCredentials: true,
        });
      } catch (error) {
        console.error("Erro ao verificar autenticação:", error);

        if (ativo) {
          navigate("/login", { replace: true });
        }
      } finally {
        if (ativo) {
          setVerificandoAuth(false);
        }
      }
    };

    verificarAutenticacao();

    return () => {
      ativo = false;
    };
  }, [navigate]);

  const exibirMensagem = (texto, tipo) => {
    setMensagem(texto);
    setTipoMensagem(tipo);
  };

  const validarSenha = () => {
    if (!senhaAtual || !novaSenha || !confirmarSenha) {
      exibirMensagem("Preencha todos os campos.", "erro");
      return false;
    }

    if (novaSenha !== confirmarSenha) {
      exibirMensagem("As novas senhas não coincidem.", "erro");
      return false;
    }

    if (novaSenha === senhaAtual) {
      exibirMensagem(
        "A nova senha deve ser diferente da senha atual.",
        "erro"
      );
      return false;
    }

    if (novaSenha.length < 8) {
      exibirMensagem(
        "A nova senha deve ter pelo menos 8 caracteres.",
        "erro"
      );
      return false;
    }

    return true;
  };

  const handleAlterarSenha = async (e) => {
    e.preventDefault();

    setMensagem("");
    setTipoMensagem("");

    if (!validarSenha()) {
      return;
    }

    setCarregando(true);

    try {
      const response = await api.post(
        "/alterar-senha",
        {
          senha_atual: senhaAtual,
          nova_senha: novaSenha,
        },
        {
          withCredentials: true,
        }
      );

      exibirMensagem(
        response.data?.message || "Senha alterada com sucesso!",
        "sucesso"
      );

      setSenhaAtual("");
      setNovaSenha("");
      setConfirmarSenha("");
      setMostrarSenhaAtual(false);
      setMostrarNovaSenha(false);
      setMostrarConfirmarSenha(false);
    } catch (err) {
      console.error("Erro ao alterar senha:", err);

      const mensagemErro =
        err.response?.data?.error ||
        err.response?.data?.message ||
        "Não foi possível alterar sua senha. Tente novamente.";

      exibirMensagem(mensagemErro, "erro");
    } finally {
      setCarregando(false);
    }
  };

  const renderizarCampoSenha = ({
    id,
    label,
    placeholder,
    valor,
    setValor,
    mostrar,
    alternar,
    autoComplete,
  }) => (
    <div className="acs-field">
      <label htmlFor={id}>{label}</label>

      <div className="acs-input-wrapper">
        <span className="acs-input-lock" aria-hidden="true">
          <svg
            viewBox="0 0 24 24"
            width="19"
            height="19"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="5" y="10" width="14" height="11" rx="2" />
            <path d="M8 10V7a4 4 0 0 1 8 0v3" />
          </svg>
        </span>

        <input
          id={id}
          name={id}
          type={mostrar ? "text" : "password"}
          placeholder={placeholder}
          value={valor}
          onChange={(e) => {
            setValor(e.target.value);
            if (mensagem) {
              setMensagem("");
              setTipoMensagem("");
            }
          }}
          autoComplete={autoComplete}
          required
          disabled={carregando}
        />

        <button
          type="button"
          className="acs-eye-button"
          onClick={alternar}
          aria-label={mostrar ? "Ocultar senha" : "Mostrar senha"}
          aria-pressed={mostrar}
          disabled={carregando}
        >
          <IconeOlho aberto={mostrar} />
        </button>
      </div>
    </div>
  );

  if (verificandoAuth) {
    return (
      <div className="acs-page">
        <div className="acs-loading">
          <span className="acs-spinner" />
          <p>Verificando sua sessão...</p>
        </div>
      </div>
    );
  }

  return (
    <main className="acs-page">
      <div className="acs-layout">
        <button
          type="button"
          className="acs-back"
          onClick={() => navigate("/dashboard")}
        >
          <span aria-hidden="true">←</span>
          Voltar ao dashboard
        </button>

        <header className="acs-header">
          <div className="acs-header-icon">
            <IconeEscudo />
          </div>

          <div>
            <span className="acs-eyebrow">SEGURANÇA DA CONTA</span>
            <h1>Alterar senha</h1>
            <p>
              Atualize sua senha para manter sua conta protegida.
            </p>
          </div>
        </header>

        <section className="acs-card">
          <div className="acs-card-heading">
            <h2>Atualize suas credenciais</h2>
            <p>
              Informe sua senha atual e escolha uma nova senha para sua
              conta.
            </p>
          </div>

          {mensagem && (
            <div
              className={`acs-message ${
                tipoMensagem === "sucesso"
                  ? "acs-message-success"
                  : "acs-message-error"
              }`}
              role={tipoMensagem === "erro" ? "alert" : "status"}
            >
              <span className="acs-message-icon" aria-hidden="true">
                {tipoMensagem === "sucesso" ? "✓" : "!"}
              </span>

              <p>{mensagem}</p>

              <button
                type="button"
                onClick={() => {
                  setMensagem("");
                  setTipoMensagem("");
                }}
                aria-label="Fechar mensagem"
              >
                ×
              </button>
            </div>
          )}

          <form onSubmit={handleAlterarSenha}>
            {renderizarCampoSenha({
              id: "acs-senha-atual",
              label: "Senha atual",
              placeholder: "Digite sua senha atual",
              valor: senhaAtual,
              setValor: setSenhaAtual,
              mostrar: mostrarSenhaAtual,
              alternar: () =>
                setMostrarSenhaAtual((anterior) => !anterior),
              autoComplete: "current-password",
            })}

            {renderizarCampoSenha({
              id: "acs-nova-senha",
              label: "Nova senha",
              placeholder: "Digite sua nova senha",
              valor: novaSenha,
              setValor: setNovaSenha,
              mostrar: mostrarNovaSenha,
              alternar: () =>
                setMostrarNovaSenha((anterior) => !anterior),
              autoComplete: "new-password",
            })}

            {renderizarCampoSenha({
              id: "acs-confirmar-senha",
              label: "Confirmar nova senha",
              placeholder: "Digite novamente a nova senha",
              valor: confirmarSenha,
              setValor: setConfirmarSenha,
              mostrar: mostrarConfirmarSenha,
              alternar: () =>
                setMostrarConfirmarSenha((anterior) => !anterior),
              autoComplete: "new-password",
            })}

            <div className="acs-password-hint">
              <span aria-hidden="true">ⓘ</span>
              <p>
                Recomendamos uma senha longa e exclusiva, que você não
                utilize em outros serviços.
              </p>
            </div>

            <button
              type="submit"
              className="acs-submit"
              disabled={carregando || verificandoAuth}
            >
              {carregando ? (
                <>
                  <span className="acs-spinner acs-spinner-white" />
                  Alterando senha...
                </>
              ) : (
                "Salvar nova senha"
              )}
            </button>

            <button
              type="button"
              className="acs-cancel"
              onClick={() => navigate("/dashboard")}
              disabled={carregando}
            >
              Cancelar e voltar
            </button>
          </form>
        </section>

        <footer className="acs-footer">
          <span aria-hidden="true">✓</span>
          Sua segurança é importante para nós.
        </footer>
      </div>
    </main>
  );
};

export default AlterarSenha;
